export const OpenButtonStyles = {
  color: '#101828',
  textTransform: 'capitalize',
};

export const FooterStyles = {
  borderTop: '1px solid #eaecf0',
};
